import api from "@/plugins/api";
// Sibling of `workspaceSettingsService`'s `/organisations/settings`: the BE still names this
// resource "organisation", the FE calls it "workspace" (OP-5023). Upstream is OPHUB
// `/api/v1/settings/shared-emails`; the read takes KEYCLOAK_HUB_READER_POLICY, the write
// KEYCLOAK_HUB_EDITOR_POLICY, so a reader loads this screen and cannot change the value.
const ENDPOINT = "/organisations/settings/shared-emails";
export async function getSharedEmailSetting() {
    const response = await api.get(ENDPOINT, { unwrapEnvelope: true });
    return { enabled: response.data.enabled, canDisable: response.data.canDisable };
}
/**
 * Switching off while the workspace holds a shared email is refused with a 409 carrying
 * `Settings.SharedEmail.DisableRefusedInUse` — the caller maps it through
 * `resolveApiErrorMessage` and puts the control back to its server value.
 */
export async function updateSharedEmailSetting(enabled) {
    const response = await api.put(ENDPOINT, { enabled }, { unwrapEnvelope: true });
    return { enabled: response.data.enabled, canDisable: response.data.canDisable };
}
